module.exports = __webpack_public_path__ + "img/e98c3b16-5830-6357-d4da-e8dee948cd91.ac837b48.png";